import React from 'react';
import Icon from './Icon';
import Button from './Button';
import { useUpload } from '../context/UploadContext';

// Collapsed upload tracker docked bottom-right. Shows aggregate progress while
// the modal is minimized, so uploads stay visible across navigation. Click the
// body to re-expand the full modal.
export default function UploadDock() {
  const { view, files, activeCount, doneCount, errorCount, aggregateProgress, expand, cancelAll } = useUpload();

  if (view !== 'minimized' || files.length === 0) return null;

  const busy = activeCount > 0;
  const title = busy
    ? `Uploading ${doneCount} of ${files.length}`
    : errorCount > 0
      ? `${doneCount} done · ${errorCount} failed`
      : `${doneCount} upload${doneCount === 1 ? '' : 's'} complete`;

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Show uploads"
      onClick={expand}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); expand(); } }}
      style={{
        position: 'fixed', bottom: 20, right: 20, zIndex: 900, width: 320, cursor: 'pointer',
        background: 'var(--card)', border: '1px solid var(--line)', borderRadius: 'var(--r-3)',
        boxShadow: 'var(--shadow-lg)', overflow: 'hidden',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px' }}>
        <span
          style={{
            width: 32, height: 32, borderRadius: 'var(--r-2)', flexShrink: 0,
            background: 'var(--accent-gradient)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {busy ? <span className="t-spinner" style={{ width: 15, height: 15, borderTopColor: '#fff', borderColor: 'rgba(255,255,255,0.4)' }} />
                : <Icon name={errorCount > 0 ? 'warn' : 'check'} size={16} color="#fff" />}
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 'var(--fs-sm)', fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</div>
          <div style={{ fontSize: 'var(--fs-xs)', color: 'var(--ink-3)' }}>{busy ? `${aggregateProgress}% · click to view` : 'Click to view'}</div>
        </div>
        <Button kind="ghost" size="sm" icon="chev-u" iconOnly aria-label="Expand" onClick={e => { e.stopPropagation(); expand(); }} />
        <Button kind="ghost" size="sm" icon="x" iconOnly aria-label={busy ? 'Cancel uploads' : 'Dismiss'} onClick={e => { e.stopPropagation(); cancelAll(); }} />
      </div>
      {busy && (
        <div className="t-progress" style={{ height: 4, borderRadius: 0 }}>
          <div className="t-progress-fill t-progress-fill--gradient" style={{ width: `${aggregateProgress}%`, borderRadius: 0 }} />
        </div>
      )}
    </div>
  );
}
